export { VALIDATOR_TYPE, correctFormat, dateValidator } from "./dateValidator.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/validators/dateValidator/index.mjs
// module id = 596
// module chunks = 1